var React = require('react');

function MailIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 0C1.79086 0 0 1.79086 0 4V27C0 29.2091 1.79086 31 4 31H35C37.2091 31 39 29.2091 39 27V4C39 1.79086 37.2091 0 35 0H4ZM3 5L19.5 15L36 5V9L19.5 19L3 9V5Z","fill":"#CED0D7"}));
}

MailIconInline.defaultProps = {"width":"39","height":"31","viewBox":"0 0 39 31","fill":"none"};

module.exports = MailIconInline;

MailIconInline.default = MailIconInline;
